import { useState, useEffect } from 'react'

export interface OrientationInfo {
  angle: number
  type: 'portrait' | 'landscape'
  isPortrait: boolean
  isLandscape: boolean
}

export const useOrientation = () => {
  const [orientation, setOrientation] = useState<OrientationInfo>(() => {
    // Initialize with current orientation
    if (typeof window !== 'undefined') {
      const angle = window.screen?.orientation?.angle || 0
      const isPortrait = angle === 0 || angle === 180
      return {
        angle,
        type: isPortrait ? 'portrait' : 'landscape',
        isPortrait,
        isLandscape: !isPortrait
      }
    }

    // Default fallback
    return {
      angle: 0,
      type: 'portrait',
      isPortrait: true,
      isLandscape: false
    }
  })

  useEffect(() => {
    const handleOrientationChange = () => {
      const angle = window.screen?.orientation?.angle || 0
      const isPortrait = angle === 0 || angle === 180

      setOrientation({
        angle,
        type: isPortrait ? 'portrait' : 'landscape',
        isPortrait,
        isLandscape: !isPortrait
      })
    }

    // Listen for orientation changes
    if (window.screen?.orientation) {
      window.screen.orientation.addEventListener('change', handleOrientationChange)
    } else {
      // Fallback for older browsers
      window.addEventListener('orientationchange', handleOrientationChange)
    }

    // Also listen for resize events as a fallback
    window.addEventListener('resize', handleOrientationChange)

    return () => {
      if (window.screen?.orientation) {
        window.screen.orientation.removeEventListener('change', handleOrientationChange)
      } else {
        window.removeEventListener('orientationchange', handleOrientationChange)
      }
      window.removeEventListener('resize', handleOrientationChange)
    }
  }, [])

  return orientation
}
